<script setup lang="ts">
import { ref, onMounted } from 'vue';
import SpecInfo from './spec-info.vue';
import RtuInfo from './rtu-info.vue';
import InstallInfo from './install-info.vue';
import OwnerInfo from './owner-info.vue';
import ManagerInfo from './manager-info.vue';
import { Method } from '~/enums';
import { useTocStore } from '~/store/tocStore';
import { useEquipStore } from '~/store/equipStore';

const tocStore = useTocStore();
const equipStore = useEquipStore();

const props = defineProps<{
  widget: any,
  property?: any,
}>();

const tabs = computed(() => {
  let result = [];

  console.log(props.widget);

  for(let i = 0; i < props.widget.data.length; i++){
    if(!props.property || props.property.geoType !== 'drgeo'){
      result.push(props.widget.data[i]);
    } else {
      if(props.widget.data[i].type !== 'owner'){
        result.push(props.widget.data[i]);
      }
    }
  }

  return result;
});

const specInfoType = computed(() => {
  if(tabs.value.find((v: any) => v.type === 'spec').url.includes('spec-infos')){
    return 'drgeo';
  } else {
    return 'normal';
  }
})

const cid = computed(() => {
  if(tabs.value.find((v: any) => v.type === 'spec').url.includes('spec-infos')){
    return tocStore.selectSiteInfo.cid;
  } else {
    return equipStore.selectEquipInfo.cid;
  }
});



const engSource = computed(() => equipStore.selectEquipInfo.engSource);
const rtuId = computed(() => equipStore.selectEquipInfo.rtuId);
const ownerSeq = computed(() => equipStore.selectEquipInfo.ownerSeq);

const tabData = ref();
const selectTab = ref();



async function getData(tabInfo: any){

  let url = '';
	if(tabInfo.url.includes('{cid}')){
		url = tabInfo.url.replace("{cid}", cid.value);
	} else if(tabInfo.url.includes('{rtuId}')){
		url = tabInfo.url.replace("{rtuId}", rtuId.value);
	} else if(tabInfo.url.includes('{ownerSeq}')){
    url = tabInfo.url.replace("{ownerSeq}", ownerSeq.value);
  } else {
    url = tabInfo.url;
  }

	const res = await useCustomFetch(url, {
		method: tabInfo.method as Method,
    query: {
      cid: cid.value
    }
	});

	tabData.value = res.data.value;
  selectTab.value = tabInfo.type;
}

await getData(tabs.value[0])

</script>

<template>
  <div class="info-tab p-1">
    <ul class="nav nav-tabs nav-fill" id="myTab" role="tablist">
      
      <template v-for="(tab, i) in tabs">
        <li class="nav-item" role="presentation">
          <button 
            type="button" 
            role="tab"
            data-bs-toggle="tab" 
            class="nav-link" 
            :class="tab.type === 'spec' ? 'active' : ''" 
            :id="`${tab.type}-tab`"
            :data-bs-target="`#${tab.type}-tab-pane`" 
            :aria-controls="`${tab.type}-tab-pane`" 
            :aria-selected="tab.type === 'spec'" 
            @click="getData(tab)"
          >
            {{ tab.name }}
          </button>   
        </li>
      </template>
    </ul>
  </div>

<!-- <div class="info-tab p-1 h-5">
  <ul class="nav nav-tabs nav-fill" id="myTab" role="tablist">
    <li class="nav-item" v-for="tab in tabs" role="presentation">
      <button class="nav-link active" :id="tab.type" data-bs-toggle="tab" :data-bs-target="`#${tab.type}-tab-pane`"
        type="button" role="tab" :aria-controls="`${tab.type}-tab-pane`" :aria-selected="tab.type === 'spec'">
        {{ tab.type }}
      </button>
    </li>
  </ul>
</div> -->
  <div class="tab-content common-card h-100" id="equip-info-content">
    <div 
      v-for="tab in tabs"
      role="tabpanel" 
      tabindex="0"
      class="tab-pane fade" 
      :class="tab.type === 'spec' ? 'show active' : ''" 
      :id="`${tab.type}-tab-pane`" 
      :aria-labelledby="`${tab.type}-tab`" 
    >
      <SpecInfo v-if="tab.type === 'spec' && selectTab === 'spec'" :eng-source="engSource as string" :spec-data="tabData" :specInfoType="specInfoType"/>
      <RtuInfo v-else-if="tab.type === 'rtu' && selectTab === 'rtu'" :rtuInfo="tabData" />
      <InstallInfo v-else-if="tab.type === 'install' && specInfoType !== 'drgeo' && selectTab === 'install'" :install-info="tabData" :specInfoType="specInfoType"/>
      <OwnerInfo v-else-if="tab.type === 'owner' && specInfoType !== 'drgeo' && selectTab === 'owner'" :ownerInfo="tabData" :cid="cid" />
      <ManagerInfo v-else-if="tab.type === 'manager' && selectTab === 'manager'" :managerInfo="tabData" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-card.scss";

.info-tab {
  .nav {
    border-bottom: none;

    .nav-item {
      button {
        @include define_font.text-normal-12;
        padding: 10px;
        color: #6B7271;
        font-weight: 500;
        line-height: 135%;
        transition: all 150ms ease-in-out;
        box-shadow: none;
        box-sizing: border-box;
        border: 1px solid transparent;

        &:hover {
          color: #3670ab;
        }

        &.active {
          color: #007CE1;
          border: 1px solid #dee2e6;
          border-bottom: 3px solid #007ce1;
        }
      }
    }
  }
}

.tab-content {
  & .tab-pane {
    height: 100%;

    & .content {
      background-color: #FFF;
      border-radius: 0;
      padding: 0;
      box-shadow: none;
      overflow: auto;
    }
  }
}
</style>